import { fromJS } from 'immutable';
import {getError} from '../utils/Utils';
import RedeemActions from '../actions/RedeemActions';

export const DEFAULT_STATE = fromJS({
});

const {
    REDEEM,
    REDEEM_SUCCESS,
    REDEEM_FAILED,
    CLEAR_ERROR
} = RedeemActions.TYPES;

export default function(state = DEFAULT_STATE, action) {
    let newState = state;
    switch (action.type) {
        case REDEEM: {
            const payload = action.payload;
            newState = newState.updateIn(['loading'], () => true);
            newState = newState.updateIn(['action'], () => true);
            newState = newState.updateIn(['error'], () => null);
            newState = newState.updateIn(['payload'], () => payload);
            return newState;
        }
        case REDEEM_SUCCESS: {
            newState = newState.updateIn(['loading'], () => false);
            newState = newState.updateIn(['error'], () => null);
            return newState;
        }
        case REDEEM_FAILED: {
            const error = getError(action.payload);
            newState = newState.updateIn(['loading'], () => false);
            newState = newState.updateIn(['error'], () => error);
            return newState;
        }
        case CLEAR_ERROR: {
            newState = newState.updateIn(['error'], () => null);
            return newState;
        }

        default:
            return newState;
    }
}
